import React, { useEffect, useState } from "react";
import "./home.css";
import Menu from "../../components/menu/menu";
import { SlSocialLinkedin } from "react-icons/sl";
import { VscGithubAlt } from "react-icons/vsc";
import { AiOutlineWhatsApp } from "react-icons/ai";
import { FiArrowRight } from "react-icons/fi";
import { Link } from "react-router-dom";

const Home = () => {
  const [displayedText, setDisplayedText] = useState("");
  const fullText = "Desenvolvedor Full Stack";
  const typingSpeed = 50;

  useEffect(() => {
    let index = 0;
    const interval = setInterval(() => {
      if (index < fullText.length) {
        setDisplayedText(fullText.slice(0, index + 1));
        index++;
      } else {
        clearInterval(interval);
      }
    }, typingSpeed);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Menu url="home" />
      
      <main className="home-page">
        <div className="home-container">
          <section className="hero-section about-section">
            
            <div className="hero-content">
              <div className="hero-header">
                <h1 className="hero-title">
                  Olá! Eu sou <span className="highlight">Leonardo Souza</span>
                </h1>
                
                <div className="typing-wrapper">
                  <p className="typing-text">
                    <span className="typing-display">{displayedText}</span>
                    <span className="typing-cursor"></span>
                  </p>
                </div>
              </div>

              <p className="hero-description">
                Especialista em criar soluções modernas e escaláveis. 
                Formado em <strong>Análise e Desenvolvimento de Sistemas</strong>.
                <br />
                <strong>Belo Horizonte, Brasil</strong>.
              </p>

              {/* CTA Buttons */}
              <div className="hero-actions">
                <Link to="/portfolio" className="btn  btn-project-primary btn-large">
                  Ver Meus Projetos
                  <FiArrowRight />
                </Link>
              </div>

              {/* Redes Sociais */}
              <div className="social-links">
                <a
                  href="https://www.linkedin.com/in/leonardo-oliveira-3b0446176/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Perfil no LinkedIn"
                  title="LinkedIn"
                >
                  <SlSocialLinkedin />
                </a>

                <a
                  href="https://github.com/Leonardu76"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Perfil no GitHub"
                  title="GitHub"
                >
                  <VscGithubAlt />
                </a>

                <a
                  href="https://api.whatsapp.com/send?phone=5531985808502&text=Olá! Vim através do seu portfólio"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label="Contato via WhatsApp"
                  title="WhatsApp"
                >
                  <AiOutlineWhatsApp />
                </a>
              </div>
            </div>
          </section>
        </div>
      </main>
    </>
  );
};

export default Home;
